/* eslint-disable max-len */
import ZilQuestion from 'images/coin-pages/questions/zil.svg'

import { ICoinPageData } from '../types'

export const zilPage: ICoinPageData = {
  title: 'coin_1234',
  description: 'coin_1235',
  metaDescription: 'coin_zil_meta_desc',
  metaTitle: 'coin_zil_meta_title',
  questionsBlock: {
    image: ZilQuestion,
    questions: [
      {
        title: 'coin_1236',
        answer: 'coin_1237',
      },
      {
        title: 'coin_1238',
        answer: 'coin_1239',
      },
      {
        title: 'coin_1240',
        answer: 'coin_1241',
      },
      {
        title: 'coin_1242',
        answer: 'coin_1243',
      },
      {
        title: 'coin_1244',
        answer: 'coin_1245',
      },
    ],
  },
  whatIs: {
    text: ['coin_1248'],
    paragraphs: [
      {
        title: 'coin_1246',
        text: ['coin_1249', 'coin_1250', 'coin_1251', 'coin_1252'],
      },
      {
        title: 'coin_1247',
        text: ['coin_1253', 'coin_1254', 'coin_1255', 'coin_1256', 'coin_1257'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/zilliqa-partnership/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/05/Zilliqa-partnership.png',
        imageAlt: 'Zilliqa (ZIL) review 1',
      },
      {
        link: 'https://coinrabbit.io/blog/cryptocrash/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/05/0.-Title.png',
        imageAlt: 'Zilliqa (ZIL) review 2',
      },
      {
        link: 'https://coinrabbit.io/blog/6-best-crypto-loan-use-cases-for-2022/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/03/p.png',
        imageAlt: 'Zilliqa (ZIL) review 3',
      },
    ],
  },
}
